"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceHazardTile = void 0;
const SelectSpace_1 = require("../inputs/SelectSpace");
const DeferredAction_1 = require("./DeferredAction");
const AresHazards_1 = require("../ares/AresHazards");
const LogHelper_1 = require("../LogHelper");
const TileType_1 = require("../TileType");
const CardName_1 = require("../CardName");
const SelectProductionToLoseDeferred_1 = require("./SelectProductionToLoseDeferred");
class PlaceHazardTile {
    constructor(player, game, title = 'Select space for hazard tile', spaces = [], options = {}) {
        this.player = player;
        this.game = game;
        this.title = title;
        this.spaces = spaces;
        this.options = options;
        this.priority = DeferredAction_1.Priority.DEFAULT;
    }
    execute() {
        if (this.spaces.length === 0) {
            return undefined;
        }
        return new SelectSpace_1.SelectSpace(this.title, this.spaces, TileType_1.TileType.DUST_STORM_MILD, (foundSpace) => {
            const tileType = Math.floor(Math.random() * 2) === 0 ? TileType_1.TileType.DUST_STORM_MILD : TileType_1.TileType.EROSION_MILD;
            AresHazards_1._AresHazardPlacement.putHazardAt(foundSpace, tileType);
            if (this.options.collectBonuses) {
                foundSpace.bonus.forEach((spaceBonus) => this.game.grantSpaceBonus(this.player, spaceBonus));
            }
            if (this.options.productionPenalty) {
                this.game.board.getAdjacentSpaces(foundSpace).forEach((space) => {
                    if (space.player !== undefined && space.player !== this.player) {
                        if (!space.player.isCorporation(CardName_1.CardName.ATHENA)) {
                            this.game.defer(new SelectProductionToLoseDeferred_1.SelectProductionToLoseDeferred(space.player, 1));
                        }
                    }
                });
            }
            LogHelper_1.LogHelper.logTilePlacement(this.player, foundSpace, tileType);
            return undefined;
        });
    }
}
exports.PlaceHazardTile = PlaceHazardTile;
//# sourceMappingURL=PlaceHazardTile.js.map